import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    particelle: [],
    cultura: [],
    varieta: [],
    certificazioni: [],
    singleParticelle: null,
    isLoading: false,
    error: null,
};
const particelleSlice = createSlice({
    name: "particelle",
    initialState,
    reducers: {
        setParticelle: (state, action) => {
            console.log(action.payload, "action.payload")
            state.particelle = action.payload;
        },
        addParticelle: (state, action) => {
            state.particelle.push(action.payload);
        },
        getCultura: (state, action) => {
            state.cultura = action.payload;
        },
        getVarieta: (state, action) => {
            state.varieta = action.payload;
        },
        getCertificazioni: (state, action) => {
            state.certificazioni = action.payload;
        },
        setSingleParticelle: (state, action) => {
            // console.log("Updating Redux state with sensor data:", action.payload); // :white_check_mark: Check Redux update
            state.singleParticelle = action.payload;
        },
        updateParticelle: (state, action) => {
            const index = state.particelle.findIndex(
                (item) => item.id === action.payload.id
            );
            if (index !== -1) {
                state.particelle[index] = action.payload;
            }
        },
        deleteParticelle: (state, action) => {
            state.particelle = state.particelle.filter(
                (item) => item.id !== action.payload
            );
        },
        apiRequestStart: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        apiRequestSuccess: (state) => {
            state.isLoading = false;
        },
        apiRequestFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
    },
});
export const {
    setParticelle,
    addParticelle,
    setSingleParticelle,
    updateParticelle,
    deleteParticelle,
    apiRequestStart,
    apiRequestSuccess,
    apiRequestFailure,
    getCultura,
    getVarieta,
    getCertificazioni
} = particelleSlice.actions;
export const selectparticelle = (state) => state.particelle?.particelle;
export const selectSingleparticelle = (state) => state.particelle?.singleparticelle
export const selectIsLoading = (state) => state.particelle?.isLoading;
export const selectError = (state) => state.particelle?.error;
export default particelleSlice.reducer;